<template>
  <div class="bodycontent">
    <div class="bodycontent_2">
      <div class="page_title">
        账号安全设置
      </div>
      <div class="table_box">
        <div class="box1">
          <div class="box2">
            <img
              style="width: 50px;margin-right: 20px"
              src="../../../../../../public/img/icons/psw.png"
            />
            <div style="font-size: 20px;margin-right: 20px">登录密码</div>
            <div style="font-size: 16px;color: #cccccc">
              定期更换有助于账号安全
            </div>
          </div>
          <div class="box3">
            <el-button
              @click="Is_psw = true"
              style="border-radius: 50px;width: 200px;color: #00a4ff;border: #00e5ff solid 1px"
              >修改密码</el-button
            >
          </div>
        </div>
        <div class="box1">
          <div class="box2">
            <img
              style="width: 50px;margin-right: 20px"
              src="../../../../../../public/img/icons/phone.png"
            />
            <div style="font-size: 20px;margin-right: 20px">登录手机</div>
            <div style="font-size: 16px;color: #cccccc">{{ adminMobile }}</div>
          </div>
          <div class="box3">
            <el-button
              @click="Is_phone = true"
              style="border-radius: 50px;width: 200px;color: #00a4ff;border: #00e5ff solid 1px"
              >修改手机</el-button
            >
          </div>
        </div>
      </div>
    </div>
    <el-dialog :visible.sync="Is_psw" title="密码修改" width="400px">
      <el-form
        ref="form"
        :model="form"
        status-icon
        :rules="rules"
        label-width="100px"
      >
        <el-form-item label="用户手机号">
          <el-input v-model="form.mobile" disabled></el-input>
        </el-form-item>
        <verificationCode
          :form="{
            mobile: form.mobile
          }"
          :typeCode="1"
          v-model="form.verification_code"
        ></verificationCode>
        <!-- <el-form-item label="验证码">
          <el-input class="input_box" v-model="form.verification_code">
            <template slot="append">
              <el-link
                :disabled="btn_status"
                @click="getCode(form.mobile)"
                type="primary"
                >{{ code_text }}</el-link
              >
            </template>
          </el-input>
        </el-form-item> -->
        <el-form-item label="新密码">
          <el-input
            show-password
            v-model="re_pay_pass"
            placeholder="请输入六位数字密码"
            autocomplete="off"
          ></el-input>
        </el-form-item>
        <el-form-item label="确认密码" prop="password">
          <el-input
            show-password
            v-model="form.password"
            autocomplete="off"
          ></el-input>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="Isdone('pws')">取 消</el-button>
        <el-button type="primary" @click="pwsEdit('form')">修改密码</el-button>
      </span>
    </el-dialog>
    <el-dialog :visible.sync="Is_phone" title="账号修改" width="400px">
      <el-form :model="form" label-width="100px">
        <el-form-item label="新手机号">
          <el-input v-model="mobile"></el-input>
        </el-form-item>
        <verificationCode
          :form="{
            mobile: mobile
          }"
          :typeCode="1"
          v-model="form.verification_code"
        ></verificationCode>
        <!-- <el-form-item label="验证码">
          <el-input class="input_box" v-model="form.verification_code">
            <template slot="append">
              <el-link
                :disabled="btn_status"
                @click="getCode(mobile)"
                type="primary"
              >{{ code_text }}</el-link
              >
            </template>
          </el-input>
        </el-form-item> -->
        <el-form-item label="密码">
          <el-input
            show-password
            v-model="form.password"
            placeholder="请输入六位数字密码"
            autocomplete="off"
          ></el-input>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="Isdone('phone')">取 消</el-button>
        <el-button type="primary" @click="mobileEdit">修 改</el-button>
      </span>
    </el-dialog>
  </div>
</template>
<script>
import { admin_mobile, admin_mobileEdit, passwordEdit } from "@/api/vip";
import { iCSendSms } from "@/api/ic";
import { mapGetters } from "vuex";
import verificationCode from "@Components/verification/verificationCode";

export default {
  components: {
    verificationCode
  },
  computed: {
    ...mapGetters(["token", "app_id"])
  },
  data() {
    var validatePass = (rule, value, callback) => {
      if (value === "") {
        callback(new Error("请再次输入密码"));
      } else if (value !== this.re_pay_pass) {
        callback(new Error("两次输入密码不一致!"));
      } else {
        callback();
      }
    };
    return {
      Is_psw: false,
      Is_phone: false,
      adminMobile: "",
      mobile: "",
      form: {
        mobile: "",
        verification_code: "",
        password: ""
      },
      re_pay_pass: "",
      code_text: "获取验证码",
      timer: null,
      count: 0,
      btn_status: false,
      rules: {
        password: [{ validator: validatePass, trigger: "blur" }]
      }
    };
  },
  mounted() {
    this.init();
  },
  watch: {},
  methods: {
    getInputValue(e) {
      console.log("获取的输入内容", e);
    },
    init() {
      this.get_admin_mobile();
    },
    async get_admin_mobile() {
      const res = await admin_mobile({ app_id: this.app_id });
      if (res.code == 200) {
        this.form.mobile = res.data;
        this.adminMobile = res.data.slice(0, 3) + "****" + res.data.slice(-4);
      }
    },
    getCode(phone) {
      const TIME_COUNT = 60;
      if (!this.timer) {
        this.count = TIME_COUNT;
        this.SendUserCode(phone);
        this.timer = setInterval(() => {
          if (this.count > 0 && this.count <= TIME_COUNT) {
            this.count--;
            this.code_text = this.count + "s";
            this.btn_status = true;
          } else {
            this.btn_status = false;
            this.timer = null;
            this.code_text = "获取验证码";
          }
        }, 1000);
      }
    },
    // 向用户发送验证码
    async SendUserCode(phone) {
      try {
        var data = {
          app_id: this.app_id,
          mobile: phone
        };
        const res = await iCSendSms(data);
        if (res.code == 200) {
          this.$message.success(res.msg);
        } else {
          this.$message.error(res.msg);
        }
      } catch (error) {
        console.log(error);
      }
    },
    //密码修改
    pwsEdit(formName) {
      this.form.app_id = this.app_id;
      this.$refs[formName].validate(valid => {
        if (valid) {
          passwordEdit(this.form).then(res => {
            if (res.code == 200) {
              this.$message.success(res.msg);
              this.Isdone("pws");
              localStorage.removeItem("token");
              setTimeout(() => {
                location.reload();
              }, 500);
            } else {
              this.$message.error(res.msg);
            }
          });
        } else {
          console.log("检查密码!");
          return false;
        }
      });
    },
    //账号修改
    async mobileEdit() {
      this.form.app_id = this.app_id;
      this.form.mobile = this.mobile;
      const res = await admin_mobileEdit(this.form);
      if (res.code == 200) {
        this.$message.success(res.msg);
        this.Isdone("phone");
        localStorage.removeItem("token");
        setTimeout(() => {
          location.reload();
        }, 500);
      } else {
        this.$message.error(res.msg);
      }
    },
    //关闭弹窗
    Isdone(key) {
      this.get_admin_mobile();
      if (key == "pws") {
        this.$refs["form"].resetFields();
        this.Is_psw = false;
        this.$nextTick(() => {
          this.form.password = "";
          this.form.verification_code = "";
          this.re_pay_pass = "";
        });
      }
      if (key == "phone") {
        this.Is_phone = false;
        this.$nextTick(() => {
          this.form.password = "";
          this.form.verification_code = "";
          this.mobile = "";
        });
      }
    }
  }
};
</script>
<style lang="scss" scoped>
.bodycontent {
  background: #f0f2f5;
  border: 20px solid #f0f2f5;
  height: 100%;
  overflow: auto;
  padding: 0 18px;
  .bodycontent_2 {
    background: #ffffff;
    height: 100%;
    padding: 0 20px;
    width: 80%;
    margin: 0 auto;
    .page_title {
      height: 60px;
      line-height: 60px;
      font-size: 18px;
      border-bottom: 1px dashed #eee;
    }
    .table_box {
      margin: 10px 0;
      .box1 {
        padding: 0 20px;
        margin: 0 auto;
        width: 90%;
        border-bottom: #cccccc dashed 1px;
        height: 100px;
        display: flex;
        align-items: center;
        .box2 {
          width: 75%;
          padding: 0 20px;
          display: flex;
          align-items: center;
        }
        .box3 {
          width: 25%;
          padding: 0 20px;
          display: flex;
          align-items: center;
        }
      }
    }
  }
}
.page_form {
  .input_box {
    width: 150px;
    margin-right: 10px;
  }
  .input_box_small {
    width: 50px;
  }
  .form_info_text {
    color: #aaa;
  }
  .bottom_btn {
    margin-top: 40px;
    text-align: center;
  }
}
</style>
